import { Component } from '@theme/component';
import { getStore, formatMoney } from '@theme/it-pdp-store';

/**
 * IT PDP — price.
 *
 * Redraws from the store rather than from a section re-fetch, so switching
 * size or colour costs nothing over the network.
 */
class ItPdpPrice extends Component {
  requiredRefs = ['now'];

  #unsubscribe;

  connectedCallback() {
    super.connectedCallback();

    const store = getStore(this);
    if (!store) return;

    this.#unsubscribe = store.subscribe(({ variant, moneyFormat }) => {
      // A partial choice leaves the server-rendered price standing; blanking
      // it mid-selection would read as a broken page.
      if (!variant) return;

      const { now, was, off } = this.refs;
      const onSale = variant.compareAtPrice > variant.price && variant.price > 0;

      now.textContent = formatMoney(variant.price, moneyFormat);

      if (was) {
        was.textContent = formatMoney(variant.compareAtPrice, moneyFormat);
        was.hidden = !onSale;
      }

      if (off) {
        off.hidden = !onSale;
        if (onSale) {
          const pct = Math.round(((variant.compareAtPrice - variant.price) / variant.compareAtPrice) * 100);
          off.textContent = `${pct}% off`;
        }
      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#unsubscribe?.();
  }
}

if (!customElements.get('it-pdp-price')) {
  customElements.define('it-pdp-price', ItPdpPrice);
}
